module.exports = __webpack_public_path__ + "img/ic_extern.7511d3a8.svg";